import React from 'react';
import { observer } from 'mobx-react';

import styles from '../../theme';
import Iframe from '../../components/Iframe/Iframe';
import Media from 'react-media';
import { useStores } from '../../store/useStores';

function ResultView() {
  const {
    authStore: { user, isImpersonator }
  } = useStores();
  const currentUser = isImpersonator || user;

  return (
    <Media query={{ maxWidth: styles.mq.large }}>
      {matches =>
        currentUser.email && (
          <Iframe
            src="/discover/result/pdf"
            height={matches ? 'calc(100vh - 145px)' : '100%'}
          />
        )
      }
    </Media>
  );
}

export default observer(ResultView);
